import { render } from "./extension.vue?vue&type=template&id=c9be137c&scoped=true"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"

import "./extension.vue?vue&type=style&index=0&id=c9be137c&lang=less&scoped=true"

import exportComponent from "/Users/imp/work/sathikash_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9be137c"]])

export default __exports__